module.exports = __webpack_public_path__ + "static/images/hero.e85d07e274b10abeb707740846a1482b.jpg";